import { jsx as _jsx } from "react/jsx-runtime";
import { LoggedOutContactFormLinkFormatting } from "@faire/retailer-visitor-shared/components/Links";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Button } from "@faire/web--source/slate/Button";
import { Row, Column } from "@faire/web--source/slate/Layout";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackSigninTooManyAttemptsContactUsClick } from "@faire/web-api--source/events/signin/click/tooManyAttemptsContactUs";
import { MfaMethod } from "@faire/web-api--source/indigofair/data/MfaMethod";
import React from "react";
export var ResendCode = function(param) {
    var error = param.error, onResend = param.onResend, showResend = param.showResend, mfaMethod = param.mfaMethod;
    var strictLocalize = useStrictLocalization().strictLocalize;
    //For usage on enterMFA view, since it already has a custom error message, we wont pass the error to this component
    if (error) {
        return /*#__PURE__*/ _jsx(Typography, {
            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "xgik6d",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Sorry! We encountered an unexpected error, please "
                    },
                    {
                        type: 8,
                        value: "LoggedOutContactFormLinkFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Contact Us"
                            }
                        ]
                    }
                ],
                values: {
                    LoggedOutContactFormLinkFormatting: LoggedOutContactFormLinkFormatting
                }
            })
        });
    }
    var resendCTAText = mfaMethod === MfaMethod.SMS ? strictLocalize({
        id: "G5ujgH",
        defaultMessage: [
            {
                type: 0,
                value: "Resend code"
            }
        ]
    }) : strictLocalize({
        id: "vHIkKA",
        defaultMessage: [
            {
                type: 0,
                value: "Resend email"
            }
        ]
    });
    return /*#__PURE__*/ _jsx(Row, {
        children: /*#__PURE__*/ _jsx(Column, {
            align: "center",
            children: /*#__PURE__*/ _jsx(Typography, {
                children: showResend ? /*#__PURE__*/ _jsx(Button, {
                    variant: "tertiary",
                    onClick: onResend,
                    children: resendCTAText
                }) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "lbvnwk",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Code resent. Still didn't receive it? "
                        },
                        {
                            type: 8,
                            value: "LoggedOutContactFormLinkWithPETEFormatting",
                            children: [
                                {
                                    type: 0,
                                    value: "Contact Us"
                                }
                            ]
                        }
                    ],
                    values: {
                        LoggedOutContactFormLinkWithPETEFormatting: function(chunk) {
                            return LoggedOutContactFormLinkFormatting(chunk, function() {
                                return trackSigninTooManyAttemptsContactUsClick();
                            });
                        }
                    }
                })
            })
        })
    });
};
